import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import TopCommercialCleanersWrapper from "@components/layouts/topcommercialcleanersWrapper";

export default function TopCommercialCleanersHome(): ReactElement {
    return (
        <TopCommercialCleanersWrapper>
            <PrivacyPolicy
                category="Commercial Cleaners"
                domain="TopCommercialCleaners.com"
            />
        </TopCommercialCleanersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
